import React, { useEffect, useState, useMemo } from "react";
import {
  Stack,
  Typography,
  Alert,
  TextField,
  Button,
  Box,
} from "@mui/material";
import MuiModal from "../atoms/MuiModal";
import InputLabel from "../atoms/InputLabel";
import ButtonComponent from "../atoms/ButtonComponent";
import { socketWex } from "../../utils/Socket";
import AlertComponent from "../atoms/Alert";
import stylesAgent from "../../styles/Molecules/Agents/styleAgents";
import useRegions from "../../hooks/useRegions";
import SwitchComponent from "../atoms/SwitchControler";
import AutoCompleteComponent from "../atoms/AutoCompleteComponent";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";

const DEFAULT_AGENT = "00001";

const getPrefillValue = (source, ...pathGroups) => {
  for (const paths of pathGroups) {
    let current = source;
    let found = true;

    for (const key of paths) {
      if (current == null || typeof current !== "object" || !(key in current)) {
        found = false;
        break;
      }
      current = current[key];
    }

    if (found && current !== undefined && current !== null && current !== "") {
      return current;
    }
  }

  return "";
};

export const getInitialFormPrefill = (initialData = {}, location = null) => {
  const raw = initialData?.raw || {};
  const incidentData = initialData?.incidentData || raw?.incidentData || {};
  const dataArray = initialData?.data || raw?.data || [];

  const formattedLocation =
    typeof location === "string"
      ? location
      : location && typeof location === "object"
        ? `${Number(location.lat).toFixed(6)}, ${Number(location.lng).toFixed(6)}`
        : "";

  const fullName = String(
    getPrefillValue(
      initialData,
      ["client"],
      ["name"],
      ["data", 1],
      ["header", "client"],
      ["header", "name"],
      ["incidentData", "name"],
      ["raw", "incidentData", "name"],
    ) ||
      getPrefillValue(incidentData, ["name"], ["client"], ["data", 1]) ||
      getPrefillValue(raw, ["name"], ["client"], ["data", 1]) ||
      "",
  ).trim();

  const parts = fullName.split(/\s+/).filter(Boolean);

  let name = "";
  let lastName = "";

  if (parts.length >= 3) {
    lastName = parts.slice(-2).join(" ");
    name = parts.slice(0, -2).join(" ");
  } else if (parts.length === 2) {
    name = parts[0];
    lastName = parts[1];
  } else if (parts.length === 1) {
    name = parts[0];
  }

  return {
    name,
    lastName,
    phone: String(
      getPrefillValue(
        initialData,
        ["phone"],
        ["anchor"],
        ["data", 0],
        ["incidentData", "phone"],
        ["raw", "incidentData", "phone"],
      ) ||
        getPrefillValue(incidentData, ["phone"], ["anchor"], ["data", 0]) ||
        getPrefillValue(raw, ["phone"], ["anchor"], ["data", 0]) ||
        dataArray[0] ||
        "",
    ).trim(),
    folio: String(
      getPrefillValue(
        initialData,
        ["externalFolio"],
        ["folio"],
        ["data", 2],
        ["incidentData", "externalFolio"],
        ["raw", "incidentData", "externalFolio"],
        ["header", "externalFolio"],
        ["header", "folio"],
      ) ||
        getPrefillValue(incidentData, ["externalFolio"], ["folio"], ["data", 2]) ||
        getPrefillValue(raw, ["externalFolio"], ["folio"], ["data", 2]) ||
        dataArray[2] ||
        "",
    ).trim(),
    reference: String(
      getPrefillValue(
        initialData,
        ["location"],
        ["ubicationClient"],
        ["data", 4],
        ["incidentData", "location"],
        ["raw", "incidentData", "location"],
      ) ||
        getPrefillValue(incidentData, ["location"], ["ubicationClient"], ["data", 4]) ||
        getPrefillValue(raw, ["location"], ["ubicationClient"], ["data", 4]) ||
        dataArray[4] ||
        formattedLocation ||
        "",
    ).trim(),
    comments: String(
      getPrefillValue(
        initialData,
        ["comments"],
        ["data", 3],
        ["incidentData", "comments"],
        ["raw", "incidentData", "comments"],
      ) ||
        getPrefillValue(incidentData, ["comments"], ["data", 3]) ||
        getPrefillValue(raw, ["comments"], ["data", 3]) ||
        dataArray[3] ||
        "",
    ).trim(),
  };
};

function CabinFormModal({
  open,
  onClose,
  initialData,
  adjusters = [],
  payload,
  currentRegionId,
  formState,
  setFormState,
  createForms,
  onFormSuccess,
  onFormError,
  alertRef,
  idSupervisor,
  prefillLocation = null,
}) {
  const { getRegionById, loader, error: regionError } = useRegions();

  const {
    form = {
      name: "",
      lastName: "",
      phone: "",
      folio: "",
      reference: "",
      comments: "",
    },
    agent = DEFAULT_AGENT,
    agentConfirmed = false,
    sendNotification = true,
    adjusterWhatsappMessage = false,
  } = formState || {};

  const [alertConfig, setAlertConfig] = useState({
    show: false,
    message: "",
    type: "success",
  });
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [error, setError] = useState("");
  //Opciones PARA Zoba de atencion
  const [optionsAtentionZone, setOptionsAtentionZone] = useState([]);
  const [selectedRegion, setSelectedRegion] = useState("");
  const [selectedAgentData, setSelectedAgentData] = useState(null);
  // label agent
  const [labelAgent, setLabelAgent] = useState(null);

  // ✅ Garantizar que el agente seleccionado permanezca en la lista aunque el socket lo marque como no disponible
  const memoizedAdjusters = useMemo(() => {
    const list = [...adjusters];
    if (
      selectedAgentData &&
      !list.some((a) => a.value === selectedAgentData.value)
    ) {
      list.push(selectedAgentData);
    }
    return list;
  }, [adjusters, selectedAgentData]);

  const updateFormField = (field, value) => {
    setFormState((prev) => ({
      ...prev,
      form: { ...(prev?.form || {}), [field]: value },
    }));
  };

  const updateState = (field, value) => {
    setFormState((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  useEffect(() => {
   if (!initialData) return ;
   console.log("data inicial : ", initialData);
  }, [initialData])
  

  useEffect(() => {
    const fetchRegion = async () => {
      const response = await getRegionById(idSupervisor);
      if (response && Array.isArray(response)) {
        const formatted = response.map((reg) => ({
          label: reg.name,
          value: reg._id,
        }));
        setOptionsAtentionZone(formatted);
      } else if (response?.data && Array.isArray(response.data)) {
        const formatted = response.data.map((reg) => ({
          label: reg.name,
          value: reg._id,
        }));
        setOptionsAtentionZone(formatted);
      }
    };

    fetchRegion();
  }, [idSupervisor]);

  // ✅ Prefill cuando viene de tabla o cuando el mapa ya tiene una ubicación
  useEffect(() => {
    if (!initialData && !prefillLocation) return;

    const prefilledData = getInitialFormPrefill(initialData, prefillLocation);

    setFormState((prev) => ({
      ...prev,
      form: {
        ...(prev?.form || {}),
        name: prefilledData.name || prev?.form?.name || "",
        lastName: prefilledData.lastName || prev?.form?.lastName || "",
        phone: prefilledData.phone || prev?.form?.phone || "",
        folio: prefilledData.folio || prev?.form?.folio || "",
        reference: prefilledData.reference || prev?.form?.reference || "",
        comments: prefilledData.comments || prev?.form?.comments || "",
      },
    }));
  }, [initialData, prefillLocation, setFormState]);

  // 🛡️ Manejar recarga de página/cierre de pestaña para liberar al ajustador
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (open && agentConfirmed && !formSubmitted) {
        const selected = adjusters.find((a) => a.value === agent);
        if (selected?.agent) {
          socketWex.emit("agent-cancel-select", {
            agent: "698127b174b06a250cfc8f19", //selected.agent,
          });
        }
        // Disparar el alert genérico del navegador
        e.preventDefault();
        e.returnValue = "";
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [open, agentConfirmed, formSubmitted, agent, adjusters]);

  // 🔄 pedir ajustadores
  const getAdjustersList = (regionId) => {
    const body = {
      idService: payload?.service,
      regionIds: regionId ? [regionId] : payload.regionIds,
    };

    if (!socketWex.connected) return;

    socketWex.emit("get-adjusters", body);
  };

  const handleSelectAdjuster = (value) => {
    const selected = memoizedAdjusters.find((a) => a.value === value);
    if (selected) {
      setSelectedAgentData(selected);
    }
    updateState("agent", value);
  };

  const handleOpenAdjusters = () => {
    if (selectedRegion) {
      getAdjustersList(selectedRegion);
      //updateState("agent", DEFAULT_AGENT);
    }
  };

  // ✅ confirmar
  const handleConfirmAdjuster = () => {
    if (!agent || agent === DEFAULT_AGENT || !selectedRegion) {
      setAlertConfig({
        show: true,
        message: "Debes seleccionar un ajustador y una zona de atención",
        type: "warning",
      });
      return;
    }
    const selected = memoizedAdjusters.find((a) => a.value === agent);

    if (!selected?.agent) return;

    socketWex.emit("agent-selected", {
      idSupervisor,
      agent: selected.agent,
    });

    updateState("agentConfirmed", true);
    setError("");
  };

  // ❌ cancelar
  const handleCancelAdjuster = () => {
    if (agentConfirmed) {
      const selected = memoizedAdjusters.find((a) => a.value === agent);
      if (selected?.agent) {
        socketWex.emit("agent-cancel-select", {
          idSupervisor,
          agent: selected.agent,
        });
      }
    }

    setFormState((prev) => ({
      ...prev,
      agent: DEFAULT_AGENT,
      agentConfirmed: false,
    }));
    setSelectedRegion("");
    setError("");
  };

  // 🧾 submit
  const handleSubmit = async () => {
    if (!agentConfirmed) {
      setAlertConfig({
        show: true,
        message: "Debes confirmar el ajustador",
        type: "warning",
      });
      return;
    }

    const body = {
      name: form.name + " " + form.lastName,
      phone: form.phone,
      folio: form.folio,
      ubication: form.reference,
      comments: form.comments,
      idAgent: agent,
      idSupervisor: payload?._id,
      regionId: [selectedRegion],
      notification: sendNotification,
      adjusterWhatsappMessage: true,
    };

    try {
      const response = await createForms(body);
    
      // ✅ SUCCESS TRUE
      if (response?.success === true) {
        setAlertConfig({
          show: true,
          message: response?.message || "Formulario enviado correctamente",
          type: "success",
        });
        setFormSubmitted(true);

        // Callback para manejo en MapsReports
        onFormSuccess?.(response?.message, response, body);

        // 🔽 Scroll a alertas
        setTimeout(() => {
          alertRef?.current?.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }, 120);

        // 🔽 Cerrar modal
        setTimeout(() => {
          onClose();
        }, 2000);
      }
      // ❌ SUCCESS FALSE o respuesta inválida
      else {
        setAlertConfig({
          show: true,
          message: response?.message || "Ocurrió un error.",
          type: "error",
        });

        // Callback para manejo en MapsReports
        onFormError?.(response?.message || "Ocurrió un error.");

        setTimeout(() => {
          alertRef?.current?.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }, 120);
      }
    } catch (error) {
      console.log("error", error.message);

      setAlertConfig({
        show: true,
        message: "Error de conexión. Por favor, inténtelo de nuevo.",
        type: "error",
      });

      // Callback para manejo en MapsReports
      onFormError?.("Error de conexión. Por favor, inténtelo de nuevo.");

      setTimeout(() => {
        alertRef?.current?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }, 120);
    }
  };

  useEffect(() => {
    if (!open) {
      setFormState({
        form: {
          name: "",
          lastName: "",
          phone: "",
          folio: "",
          reference: "",
          comments: "",
        },
        agent: DEFAULT_AGENT,
        agentConfirmed: false,
        sendNotification: true,
        adjusterWhatsappMessage: false,
      });
      setSelectedRegion("");
      setSelectedAgentData(null);
      setError("");
      setFormSubmitted(false); // 👈 IMPORTANTE
      setAlertConfig({
        show: false,
        message: "",
        type: "success",
      });
    }
  }, [open, setFormState]);

  const handleCloseModal = () => {
    // ❌ cancelar si estaba confirmado pero NO enviado
    if (!formSubmitted && agentConfirmed) {
      handleCancelAdjuster();
    }

    onClose();
  };

  const ButtonsEdit = () => (
    <>
      <div style={stylesAgent.divButton}>
        <ButtonComponent
          label={agentConfirmed ? "Atrás" : "Cancelar"}
          onClick={() => {
            if (agentConfirmed) {
              handleCancelAdjuster();
            } else {
              handleCloseModal();
            }
          }}
          backgroundColor="#9a2edb"
          disabled={false}
        />
      </div>
      <div style={stylesAgent.divButton}>
        <ButtonComponent
          label={agentConfirmed ? "Enviar formulario" : "Siguiente"}
          onClick={() => {
            if (agentConfirmed) {
              handleSubmit();
            } else {
              handleConfirmAdjuster();
            }
          }}
          backgroundColor={"#1976d2"}
          //disabled={!isFormComplete}
        />
      </div>
    </>
  );

  return (
    <MuiModal
      title="Asignación de caso"
      buttons={<ButtonsEdit />}
      visible={open}
      onClose={handleCloseModal}
      width="500px"
      arrastrar={true}
    >
      <Stack spacing={2}>
        <Box ref={alertRef} />
        {alertConfig.show && (
          <AlertComponent
            message={alertConfig.message}
            typeAlert={alertConfig.type}
            handleClose={() =>
              setAlertConfig((prev) => ({ ...prev, show: false }))
            }
          />
        )}

        {!agentConfirmed && (
          <>
            <Typography
              marginBottom="0.5rem"
              marginTop="1rem"
              style={{
                fontFamily: "Raleway, sans-serif",
                fontSize: "16px",
                color: "#424242",
                fontWeight: "600",
              }}
            >
              Selecciona la zona de atención
            </Typography>

            <InputLabel
              inputType="select"
              options={optionsAtentionZone}
              selectwidth="99%"
              fontSize="15px"
              selectBgColor="#fff"
              value={selectedRegion}
              setValue={setSelectedRegion}
              disabled={agentConfirmed}
            />

            <Typography
              marginBottom="0.5rem"
              marginTop="1rem"
              style={{
                fontFamily: "Raleway, sans-serif",
                fontSize: "16px",
                color: "#424242",
                fontWeight: "600",
              }}
            >
              Selecciona un ajustador
            </Typography>

            <AutoCompleteComponent
              options={memoizedAdjusters}
              value={agent}
              onChange={handleSelectAdjuster}
              valueKey="value"
              labelKey="label"
              disabled={agentConfirmed}
              onOpen={handleOpenAdjusters}
              backgroundColor="#fff"
              width="99%"
              fontSize="15px"
            />
          </>
        )}

        {agentConfirmed && (
          <>
            <Box
              sx={{
                display: "inline-flex",
                alignItems: "center",
                gap: 1.5,
                px: 2,
                py: 1,
                backgroundColor: "grey.100", // Fondo suave
                borderRadius: 2, // Bordes redondeados
                border: "1px solid",
                borderColor: "divider",
              }}
            >
              <PersonOutlineIcon fontSize="small" color="action" />

              <Typography variant="body2" color="text.secondary">
                <Typography
                  component="span"
                  variant="subtitle2"
                  color="text.primary"
                >
                  {"Ajustador:"}
                </Typography>
                {selectedAgentData?.label} / {selectedAgentData?.agent.user}
              </Typography>
            </Box>

            <Typography
              marginBottom="0.5rem"
              marginTop="1rem"
              style={{
                fontFamily: "Raleway, sans-serif",
                fontSize: "16px",
                color: "#424242",
                fontWeight: "600",
              }}
            >
              Nombre del cliente
            </Typography>
            <Stack direction="row" style={{ width: "100%" }}>
              <Stack style={{ width: "50%", marginRight: "0.4rem" }}>
                <InputLabel
                  label="Nombre"
                  inputType="text"
                  inputwidth="92%"
                  fontSize="15px"
                  inputBgColor="#fff"
                  value={form.name}
                  setValue={(v) => updateFormField("name", v)}
                />
              </Stack>
              <Stack style={{ width: "50%" }}>
                <InputLabel
                  label="Apellidos"
                  inputType="text"
                  inputwidth="92%"
                  value={form.lastName}
                  setValue={(v) => updateFormField("lastName", v)}
                  fontSize="15px"
                  inputBgColor="#fff"
                />
              </Stack>
            </Stack>
            <Typography
              marginBottom="0.5rem"
              marginTop="1rem"
              style={{
                fontFamily: "Raleway, sans-serif",
                fontSize: "16px",
                color: "#424242",
                fontWeight: "600",
              }}
            >
              Télefono móvil del cliente
            </Typography>

            <InputLabel
              label="Teléfono"
              inputType="text"
              inputwidth="96%"
              value={form.phone}
              setValue={(v) => updateFormField("phone", v)}
              fontSize="15px"
              inputBgColor="#fff"
            />
            <Typography
              marginBottom="0.5rem"
              marginTop="1rem"
              style={{
                fontFamily: "Raleway, sans-serif",
                fontSize: "16px",
                color: "#424242",
                fontWeight: "600",
              }}
            >
              Notificación para el cliente
            </Typography>
            <Stack direction="row" alignContent="flex-end" m={2}>
              <SwitchComponent
                label="¿Enviar notificación?"
                checked={sendNotification}
                onChange={(e) =>
                  updateState("sendNotification", e.target.checked)
                }
              />
            </Stack>

            <Typography
              marginBottom="0.5rem"
              marginTop="1rem"
              style={{
                fontFamily: "Raleway, sans-serif",
                fontSize: "16px",
                color: "#424242",
                fontWeight: "600",
              }}
            >
              Enviar notificación Whatsapp al ajustador
            </Typography>
            <Stack direction="row" alignContent="flex-end" m={2}>
              <SwitchComponent
                label="¿Enviar notificación?"
                checked={true}
                disabled={true}
              />
            </Stack>

            <Alert
              severity="info"
              sx={{
                marginTop: "0.5rem",
                fontSize: "1rem",
                padding: "10px",
              }}
            >
              Se necesita para garantizar la comunicación mediante mensaje
              digital
            </Alert>

            <Typography
              marginBottom="0.5rem"
              marginTop="1rem"
              style={{
                fontFamily: "Raleway, sans-serif",
                fontSize: "16px",
                color: "#424242",
                fontWeight: "600",
              }}
            >
              Folio del Siniestro
            </Typography>

            <InputLabel
              inputwidth="96%"
              inputType="text"
              value={form.folio}
              setValue={(v) => updateFormField("folio", v)}
              fontSize="15px"
              inputBgColor="#fff"
            />
            <Typography
              marginBottom="0.5rem"
              marginTop="1rem"
              style={{
                fontFamily: "Raleway, sans-serif",
                fontSize: "16px",
                color: "#424242",
                fontWeight: "600",
              }}
            >
              Georeferencia del siniestro
            </Typography>

            <InputLabel
              inputwidth="96%"
              fontSize="15px"
              inputBgColor="#fff"
              inputType="text"
              value={form.reference}
              setValue={(v) => updateFormField("reference", v)}
            />
            <Alert
              severity="warning"
              sx={{
                marginTop: "0.5rem",
                fontSize: "1rem",
                padding: "10px",
              }}
            >
              Escribir latitud y longitud separadas por coma. Ejemplo:
              19.512099557201513, -99.04559381308174
            </Alert>
            <Typography
              marginBottom="0.5rem"
              marginTop="1rem"
              style={{
                fontFamily: "Raleway, sans-serif",
                fontSize: "16px",
                color: "#424242",
                fontWeight: "600",
              }}
            >
              Referencias de ubicación
            </Typography>

            <TextField
              multiline
              rows={3}
              value={form.comments}
              onChange={(e) => updateFormField("comments", e.target.value)}
            />
          </>
        )}
      </Stack>
    </MuiModal>
  );
}
export default CabinFormModal;
